function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  .rotate-content {\n    display: none;\n  }\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 24px;\n  line-height: 1.46;\n  color: #6d747b;\n  max-width: 255px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 14px;\n  color: #6d747b;\n  text-align: center;\n  margin-bottom: 21px;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  height: ",
        "px;\n  width: ",
        "px;\n  max-width: 90vw;\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n\n  video {\n    max-width: 90vw;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
// pre-existing: react-webcam is hoisted into each app's node_modules, not packages/shared's;
// resolves fine at build/runtime.
// eslint-disable-next-line import/no-unresolved
import Webcam from 'react-webcam';
import _ from 'lodash';
import window from 'global/window';
import useStores from 'shared/hooks/use-stores';
// Imported directly (not via the shared/components barrel) to avoid a circular-import
// ordering bug: this file is now reachable (via checkout/photo-id-upload) from the
// instore-enrollment module graph, which the shared/components barrel itself transitively
// pulls in, causing Button to be undefined here in some import orders when going through
// the barrel.
import Button from 'shared/components/button';
import { SmallLoader } from 'shared/components/loading';
import { ModalClose } from 'shared/modals';
import { ModalContainer } from 'shared/modals/v2-container';
import CameraIconWhite from 'shared/assets/camera-icon-white';
import RotateImageIcon from 'shared/assets/rotate-device-icon';
var desktop = window.innerHeight > 900 || window.innerWidth > 1000;
var smallPhone = window.innerWidth < 330 || window.innerHeight < 330;
var height = desktop ? 350 : smallPhone ? 240 : 287; // eslint-disable-line
var width = desktop ? 520 : smallPhone ? 335 : 472; // eslint-disable-line
// eslint-disable-next-line no-unused-vars -- pre-existing dead code, unrelated to this change
var modalContainerStyles = css(_templateObject(), function(props) {
    return !desktop && !props.landscape && "\n    .ReactModal__Content {\n      background-color: #fff;\n      .upload-content {\n        width: 100vw;\n        overflow: hidden;\n        opacity: 0;\n        visibility: hidden;\n      }\n      .rotate-content {\n        display: block;\n        opacity: 1;\n        visibility: visible;\n        transition: opacity 0.2s;\n      }\n    }\n  ";
}, function(props) {
    return !desktop && props.landscape && "\n    .ReactModal__Content {\n      background-color: #fff;\n      width: 100vw;\n      min-height: 100vh;\n      .upload-content {\n        opacity: 1;\n        visibility: visible;\n        transition: opacity 0.2s;\n      }\n      .rotate-content {\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  ";
});
var PhotoIdCapture = /*#__PURE__*/ forwardRef(function(param, ref) {
    var handleCameraUpload = param.handleCameraUpload, onRequestClose = param.onRequestClose, containerProps = param.containerProps;
    var resize = function resize() {
        setLandscape(window.innerHeight < window.innerWidth);
    };
    var capture = function capture() {
        handleCameraUpload(webcam.current.getScreenshot());
        onRequestClose();
    };
    var onUserMediaError = function onUserMediaError(e) {
        console.log('user media error', e);
        setLoading(false);
        UI.showErnie("Unfortunately we are unable to access your camera. Please use the 'Upload a file' feature.", 'danger');
        _.delay(onRequestClose, 1500);
    };
    var close = function close() {
        onRequestClose();
        setLoading(true);
    };
    var UI = useStores().UI;
    var _useState = _sliced_to_array(useState(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), landscape = _useState1[0], setLandscape = _useState1[1];
    var webcam = useRef(null);
    useEffect(function() {
        window.addEventListener('resize', resize);
        return function() {
            window.removeEventListener('resize', resize);
        };
    });
    return /*#__PURE__*/ _jsxs(ModalContainer, _object_spread_props(_object_spread({
        ref: ref,
        isOpen: true,
        p: desktop ? '47px' : '17px 27px',
        onRequestClose: close,
        landscape: landscape
    }, containerProps), {
        children: [
            /*#__PURE__*/ _jsxs(InnerContainer, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "upload-content",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                children: "Line up your ID inside the window below"
                            }),
                            /*#__PURE__*/ _jsxs(VideoContainer, {
                                children: [
                                    loading && /*#__PURE__*/ _jsx(SmallLoader, {
                                        height: 50
                                    }),
                                    /*#__PURE__*/ _jsx(Webcam, {
                                        audio: false,
                                        height: height,
                                        ref: webcam,
                                        screenshotFormat: "image/jpeg",
                                        width: width,
                                        onUserMedia: function() {
                                            return setLoading(false);
                                        },
                                        onUserMediaError: onUserMediaError,
                                        videoConstraints: {
                                            facingMode: 'environment'
                                        },
                                        style: WebcamStyles,
                                        screenshotQuality: 1
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(RotateContainer, {
                        className: "rotate-content",
                        children: [
                            /*#__PURE__*/ _jsx(RotateImageIcon, {}),
                            /*#__PURE__*/ _jsx(RotateText, {
                                children: "Rotate your Phone to snap a photo of your ID."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ButtonContainer, {
                        className: "upload-content",
                        children: /*#__PURE__*/ _jsx(StyledButton, {
                            height: desktop ? '58px' : '100px',
                            width: desktop ? '118px' : '100px',
                            onClick: capture,
                            inverted: !desktop,
                            "aria-label": "Take photo",
                            children: /*#__PURE__*/ _jsx(CameraIcon, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalClose, {
                onClick: close
            })
        ]
    }));
});
export default PhotoIdCapture;
var RotateContainer = styled.div(_templateObject1());
var RotateText = styled.p(_templateObject2());
var InnerContainer = styled.div(_templateObject3(), !desktop && "\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    height: 100%;\n    width: 100%;\n  ");
var Text = styled.p(_templateObject4());
var VideoContainer = styled.div(_templateObject5(), height, width, !desktop && "\n    margin-bottom: 10px;\n  ");
var ButtonContainer = styled.div(_templateObject6());
var StyledButton = styled(Button)(_templateObject7(), !desktop && "\n    border-radius: 100px;\n    border: 3px solid #3989cf;\n    background-color: #4597e0;\n  ");
var WebcamStyles = {
    borderRadius: '5px',
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover'
};
var CameraIcon = styled(CameraIconWhite)(_templateObject8(), !desktop && "\n    height: 35px;\n  ");
